var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74371 5.1214C5.368 6.2192 6.2808 7.132 7.3786 7.75627L7.96827 6.93073C8.16433 6.65633 8.5344 6.57153 8.8304 6.7332C9.76827 7.24553 10.8047 7.55687 11.8859 7.64247C12.2327 7.66993 12.5 7.95927 12.5 8.30707V11.2823C12.5 11.6241 12.2415 11.9105 11.9015 11.9454C11.5482 11.9817 11.1918 12 10.8333 12C5.12639 12 0.5 7.3736 0.5 1.66667C0.5 1.30818 0.51828 0.951807 0.554593 0.598507C0.589533 0.2585 0.87596 0 1.21777 0H4.19295C4.54073 0 4.83009 0.26736 4.85753 0.61406C4.94311 1.69525 5.25447 2.73176 5.7668 3.66963C5.92847 3.9656 5.84367 4.33569 5.56927 4.53171L4.74371 5.1214ZM3.06283 4.68347L4.32947 3.77873C3.97031 3.00343 3.72419 2.18122 3.59818 1.33333H1.83938C1.83535 1.44421 1.83333 1.55533 1.83333 1.66667C1.83333 6.6372 5.8628 10.6667 10.8333 10.6667C10.9447 10.6667 11.0558 10.6647 11.1667 10.6606V8.9018C10.3188 8.7758 9.4966 8.52967 8.72127 8.17053L7.81653 9.4372C7.45053 9.295 7.09707 9.12767 6.75827 8.9374L6.71953 8.91533C5.41313 8.17247 4.32756 7.08687 3.58467 5.78047L3.56263 5.74173C3.37233 5.40293 3.20503 5.04947 3.06283 4.68347Z",
    fill: "#96999C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.685cc35f8ba8b7f9abf2379e5076a0f0.svg";
export { ForwardRef as ReactComponent };